// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/17-deutsche-nachhaltigkeitspreis/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p17DeutscheNachhaltigkeitspreisDE: PageEntry = {
  id: "post.17-deutsche-nachhaltigkeitspreis",
  locale: "de",
  slug: "17-deutsche-nachhaltigkeitspreis",
  seo: {
    title: "Die Dietz GmbH ist für den 17. Deutschen Nachhaltigkeitspreis nominiert | Dietz GmbH",
    description: "Die Dietz GmbH ist für den 17. Deutschen Nachhaltigkeitspreis nominiert",
  },
  type: "post",
  h1: "Die Dietz GmbH ist für den 17. Deutschen Nachhaltigkeitspreis nominiert",
  blocks: [
    { kind: "heading", level: 2, text: "Die Dietz GmbH ist für den 17. Deutschen Nachhaltigkeitspreis nominiert" },
    { kind: "image", src: "/images/live/Nominierungsurkunde-17.-Deutscher-Nachhaltigkeitspreis_Bild.jpg", alt: "Nominierungsurkunde 17. Deutscher Nachhaltigkeitspreis_Bild", width: 905, height: 1280 }
  ],
};
